const normalizeEnvBoolean = (value: unknown): boolean => {
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'y';
    }
    if (typeof value === 'number') {
        return value === 1;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    return false;
};

export const isAuthDisabled = (): boolean => {
    if (typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined') {
        if (Object.prototype.hasOwnProperty.call(import.meta.env, 'VITE_DISABLE_AUTH')) {
            return normalizeEnvBoolean(import.meta.env.VITE_DISABLE_AUTH);
        }
    }

    if (typeof process !== 'undefined' && typeof process.env !== 'undefined') {
        if (Object.prototype.hasOwnProperty.call(process.env, 'VITE_DISABLE_AUTH')) {
            return normalizeEnvBoolean(process.env.VITE_DISABLE_AUTH);
        }
    }

    return false;
};
